module.exports = __webpack_public_path__ + "media/customizations/landings/logo-3ca7e4f9dba57743eb73fb38f1cd3761.png";